import { InitialFlipType } from "../Models/CaseModel.js";
async function waitForImageLoad(img) {
    if (img.complete)
        return;
    return new Promise((resolve, reject) => {
        const onLoad = () => {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
            resolve();
        };
        const onError = () => {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
            reject(new Error('Failed to load image'));
        };
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
    });
}
function drawTransformedImage(img, radians, flip) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx)
        throw new Error('Failed to get 2D context from canvas');
    const cosA = Math.abs(Math.cos(radians)); // calculate new dimensions
    const sinA = Math.abs(Math.sin(radians));
    const newWidth = Math.ceil(img.width * cosA + img.height * sinA);
    const newHeight = Math.ceil(img.width * sinA + img.height * cosA);
    canvas.width = newWidth;
    canvas.height = newHeight;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const invertRotation = flip === null || flip === InitialFlipType.rotate180; // il verso di rotazione è al contrario rispetto a three.js
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(radians * (invertRotation ? -1 : 1) + (flip === InitialFlipType.rotate180 ? Math.PI : 0));
    ctx.scale(flip === InitialFlipType.horizontal ? -1 : 1, flip === InitialFlipType.vertical ? -1 : 1);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);
    return canvas;
}
export async function transformBase64(base64, radians, flip) {
    const img = new Image();
    const imageSource = base64.startsWith('data:') ? base64 : `data:image/png;base64,${base64}`;
    img.src = imageSource;
    await waitForImageLoad(img);
    return drawTransformedImage(img, radians, flip);
}
export async function transformImage(imgElement, radians, flip) {
    await waitForImageLoad(imgElement);
    return drawTransformedImage(imgElement, radians, flip);
}
export async function canvasToBase64(canvas, mimeType = 'image/png', quality = 1) {
    const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, mimeType, quality);
    });
    if (!blob)
        throw new Error('Failed to create blob from canvas');
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            // Extract base64 part (remove data URL prefix)
            const base64 = result.split(',')[1] || result;
            resolve(base64);
        };
        reader.onerror = () => reject(new Error('Failed to read blob'));
        reader.readAsDataURL(blob);
    });
}
//# sourceMappingURL=ImageUtils.js.map